module.exports = __webpack_public_path__ + "static/img/application.87f71b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/application/application.jpg
// module id = 701X
// module chunks = 0